/** Tipos dos EPIs da empresa e de seus C.A. (#551). Os ids chegam como texto do servidor. */

export interface CompanyEpiCertificate {
  id: string | number;
  numero: string;
  /** Data `AAAA-MM-DD`. */
  validade: string;
}

export interface CompanyEpi {
  id: string | number;
  companyId: string | number;
  epiId: string | number;
  epiNome: string;
  /** Orientação própria da empresa; `null` = vale a do cadastro-base. */
  orientacaoDeUso: string | null;
  orientacaoDoCadastro: string | null;
  certificates: CompanyEpiCertificate[];
}

export interface CertificateInput {
  numero: string;
  /** Data `AAAA-MM-DD`. */
  validade: string;
}

/** `AAAA-MM-DD` → `DD/MM/AAAA`, sem passar por `Date` (que deslocaria o dia pelo fuso). */
export function formatarValidade(iso: string): string {
  const [ano, mes, dia] = iso.slice(0, 10).split('-');
  return `${dia}/${mes}/${ano}`;
}

/** A data de hoje no calendário local, em `AAAA-MM-DD`. */
export function hojeIso(): string {
  const agora = new Date();
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${agora.getFullYear()}-${mes}-${dia}`;
}

/** Vencido = validade anterior a hoje; o dia da validade ainda vale. */
export function certificadoVencido(validade: string, hoje: string = hojeIso()): boolean {
  return validade.slice(0, 10) < hoje;
}
